"use strict";

var _interopRequireDefault = require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es7.object.values");
var _objectSpread2 = _interopRequireDefault(require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
var _iconLikeBlue = _interopRequireDefault(require("@/assets/common/icon-like-blue.png"));
var _iconLikeGray = _interopRequireDefault(require("@/assets/common/icon-like-gray.png"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default2 = exports.default = {
  name: 'Comment',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    currentRow: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      likeBlue: _iconLikeBlue.default,
      likeGray: _iconLikeGray.default,
      dialogImageUrl: '',
      dialogVisible: false,
      form: {
        asm: [],
        sr: [],
        images: [],
        category: '',
        content: '',
        desc: '',
        actionLikes: 0
      },
      formErrors: {
        asm: '',
        sr: '',
        desc: ''
      }
    };
  },
  computed: {
    asmList: function asmList() {
      var arr = [];
      if (this.currentRow.orgBiz && this.currentRow.orgBiz.length) {
        arr = this.currentRow.orgBiz.filter(function (item) {
          return item.bizOrgName === 'ASM';
        });
      }
      return arr;
    },
    srList: function srList() {
      var arr = [];
      if (this.currentRow.orgBiz && this.currentRow.orgBiz.length) {
        arr = this.currentRow.orgBiz.filter(function (item) {
          return item.bizOrgName === 'SR';
        });
      }
      return arr;
    },
    showBatchCommentDesc: function showBatchCommentDesc() {
      var length = this.currentRow.selected.length;
      var value = '';
      if (this.currentRow.nameKey === 'spName') {
        value = this.$t('dashboard.spBatchCommentDesc', {
          'quat': length
        });
      } else if (this.currentRow.nameKey === 'asmEmpNoName') {
        value = this.$t('dashboard.asmBatchCommentDesc', {
          'quat': length
        });
      } else if (this.currentRow.nameKey === 'srEmpNoName') {
        value = this.$t('dashboard.srBatchCommentDesc', {
          'quat': length
        });
      }
      return value;
    }
  },
  watch: {
    asmList: function asmList(val) {
      this.form.asm = val.map(function (t) {
        return t.email;
      });
    },
    srList: function srList(val) {
      this.form.sr = val.map(function (t) {
        return t.email;
      });
    }
  },
  methods: {
    uploadImage: function uploadImage(file) {
      var _this = this;
      var rawFile = file.raw;
      var param = new FormData();
      param.append('file', rawFile);
      param.append('resourceConfigFlag', 'sfe_comment');
      this.$api.common.uploadFile(param).then(function (res) {
        _this.form.images.push((0, _objectSpread2.default)((0, _objectSpread2.default)({}, file), {}, {
          URL: res.data.url
        }));
      }).catch(function () {});
    },
    toggleLike: function toggleLike() {
      this.form.actionLikes = this.form.actionLikes === 0 ? 1 : 0;
    },
    updateCategory: function updateCategory(type, content) {
      if (this.form.category === type) {
        this.form.category = '';
        this.form.content = '';
      } else {
        this.form.category = type;
        this.form.content = content;
      }
      this.validDesc(this.form.category, this.form.desc);
    },
    asmChange: function asmChange(val, email, empName) {
      if (!val) {
        this.showConfirm(email, 'asm', empName);
      } else {
        this.form.asm.push(email);
      }
      // 单行检查
      this.validAsmSr();
    },
    srChange: function srChange(val, email, empName) {
      if (!val) {
        this.showConfirm(email, 'sr', empName);
      } else {
        this.form.sr.push(email);
      }
      // 单行检查
      this.validAsmSr();
    },
    validAsmSr: function validAsmSr() {
      var pleaseSelect = this.$t('dashboard.pleaseComment');
      if (!this.form.asm.length && !this.form.sr.length) {
        this.formErrors.asm = pleaseSelect;
        this.formErrors.sr = pleaseSelect;
      } else {
        this.formErrors.asm = '';
        this.formErrors.sr = '';
      }
    },
    validDesc: function validDesc(btnDesc, inputDesc) {
      var pleaseSelect = this.$t('dashboard.pleaseComment');
      if (inputDesc.trim() !== '' || btnDesc) {
        this.formErrors.desc = '';
      } else {
        this.formErrors.desc = pleaseSelect;
      }
    },
    showConfirm: function showConfirm(email, key, empName) {
      var _this2 = this;
      var h = this.$createElement;
      var dep = key === 'asm' ? this.$t('dashboard.filter.asm') : this.$t('dashboard.filter.sr');
      this.$msgbox({
        title: 'cancel selection',
        message: h('p', null, [h('span', null, this.$t('dashboard.commentInfoConfirm')), h('span', null, " ".concat(dep, " ")), h('span', {
          style: 'fontWeight: bold'
        }, " ".concat(empName, " ")), h('span', null, '?')]),
        showCancelButton: true,
        confirmButtonText: this.$t('common.confirm'),
        cancelButtonText: this.$t('common.cancel'),
        beforeClose: function beforeClose(action, instance, done) {
          if (action === 'confirm') {
            instance.confirmButtonLoading = true;
            // 更新数据
            var arr = _this2.form[key].filter(function (item) {
              return item !== email;
            });
            _this2.form[key] = arr;
            done();
            setTimeout(function () {
              instance.confirmButtonLoading = false;
            }, 300);
          } else {
            done();
          }
        }
      });
    },
    cancelComment: function cancelComment() {
      this.$emit('close');
    },
    descChange: function descChange() {
      this.validDesc(this.form.category, this.form.desc);
    },
    submitComment: function submitComment() {
      // 校验
      if (!this.currentRow.hasOwnProperty('selected')) {
        // 单行检查
        this.validAsmSr();
      }
      this.validDesc(this.form.category, this.form.desc);
      var hasError = Object.values(this.formErrors).some(function (t) {
        return t !== '';
      });
      if (hasError) {
        return;
      }
      this.$emit('submit', this.form);
    },
    handleRemove: function handleRemove(file, fileList) {
      this.form.images = this.form.images.filter(function (item) {
        return item.uid !== file.uid;
      });
    },
    handlePictureCardPreview: function handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    }
  }
};